import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    label: {
      fontSize: '11px'
    }
  };
});
